module.exports = __webpack_public_path__ + "static/img/privacy-2.434b85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-2.png
// module id = qlyP
// module chunks = 1